import React from 'react';

import { studioTheme } from './studioTheme';
import {
  StudioWrap,
  Avatar,
  Identity,
  SourceLogo,
  Stars,
  DateText,
} from './StudioCardKit';
import { StudioBody, isMediaTestimonial, StudioMediaCard } from './StudioBody';

/**
 * Spotlight (widget type 19)
 *
 * The person leads: a large avatar centred on top, the name and role under it,
 * the rating, then the quote centred below. The card carousels have used for a
 * decade, tidied up and given room to breathe.
 */
const SpotlightCard = (props) => {
  const { cardItem, socialCardType } = props;
  const t = studioTheme(props);

  /* One body type scale per card: the text testimonial and the video/audio
     summary must read as the same widget. */
  const bodyTextStyle = { fontSize: t.smallSize ? 14 : 14.5, lineHeight: 1.55, textAlign: 'center' };

  /* A video or audio testimonial IS the card - the player already carries
     the name and work title, so none of the chrome below is drawn. Only the
     summary keeps this widget's look, as the panel it extends into. */
  if (isMediaTestimonial(cardItem, socialCardType)) {
    return (
      <StudioMediaCard
        cardItem={cardItem}
        socialCardType={socialCardType}
        t={t}
        enclosure={{
          border: `1px solid ${t.line}`,
          borderRadius: 16,
          background: t.surface,
          /* the wall's custom card colour wins, as it does on the text card */
          ...(t.cardBackgroundObject || {}),
          boxShadow: t.shadow,
        }}
        summaryStyle={bodyTextStyle}
      />
    );
  }

  return (
    <StudioWrap>
      <div
        style={{
          position: 'relative',
          borderRadius: 16,
          padding: '24px 20px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          gap: 12,
          border: `1px solid ${t.line}`,
          background: t.surface,
          ...(t.cardBackgroundObject || {}),
          boxShadow: t.shadow,
        }}
      >

        <Avatar cardItem={cardItem} size={72} />

        <Identity
          t={t}
          cardItem={cardItem}
          align="center"
          nameSize={15}
          subSize={12.5}
          truncate={false}
          style={{ alignItems: 'center' }}
        />

        <Stars t={t} cardItem={cardItem} size={14} />

        <div style={{ width: '100%' }}>
          <StudioBody
            t={t}
            cardItem={cardItem}
            socialCardType={socialCardType}
            textStyle={bodyTextStyle}
          />
        </div>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
          <SourceLogo cardItem={cardItem} />
          <DateText t={t} cardItem={cardItem} />
        </div>
      </div>
    </StudioWrap>
  );
};

export default SpotlightCard;
